package com.gastoncantera.intercom

import kotlinx.browser.window

/** Web: el UID del portero viene en el path (`/<uid>`, ej. el QR `…web.app/sFp9…`). */
actual fun startupPorteroUid(): String? =
    window.location.pathname.trim('/').substringBefore('/').takeIf { it.isNotBlank() }
